import { render, staticRenderFns } from "./ActionsSelector.vue?vue&type=template&id=66853586&scoped=true&"
import script from "./ActionsSelector.vue?vue&type=script&lang=js&"
export * from "./ActionsSelector.vue?vue&type=script&lang=js&"
import style0 from "./ActionsSelector.vue?vue&type=style&index=0&id=66853586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66853586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardTitle,VCol,VDivider,VTab,VTabItem,VTabs,VTabsItems})
